<template>
  <zpa-form-item
    :error="error"
    :success="success"
    :validating="validating"
    :required="required"
    :readonly="$readonly"
    :disabled="disabled"
    :uuid="uuid"
    :span="span"
    :push="push"
    :label="label"
    :labelWidth="labelWidth"
    :labelAlign="labelAlign"
    :itemHeight="itemHeight"
    labelVertical="start"
  >
    <Input
      type="textarea"
      :value="value"
      :rows="rows"
      :placeholder="label"
      :readonly="$readonly"
      :disabled="disabled"
      :size="size || $size"
      @on-change="onInputChange"
    />
  </zpa-form-item>
</template>

<script>
import inputMixin from './mixins/input'

export default {
  name: 'zpaTextarea',

  mixins: [inputMixin],

  data() {
    return {
      type: 'string',
    }
  },

  props: {
    rows: {
      type: Number,
      default: 4,
    },
  },
}
</script>
